import {FunctionComponent, useEffect, useState} from 'react';
import FormLabel from '@mui/material/FormLabel';
import styles from './styles.module.css';
import {styledMod} from '@/utils/styled-mod.tsx';
import type TokenMetadataItem from '@/components/tokens/types/token-metadata-item.ts';

export const ButtonLabel = styledMod(FormLabel, styles['button-label']);
export const ButtonLabelsContainer = styledMod(FormLabel, styles['button-labels-container']);

type TokenPresetButtonsProps = {
  tokensMetadata: TokenMetadataItem[];
  onTokenAddressChange: (tokenName: string, tokenAddress: string, imgSrc: string) => void;
  activeToken: string;
}

// const USDT_TOKEN = 'USDT';
const REDOI_TOKEN = 'REDOI';

const TokenPresetButtons: FunctionComponent<TokenPresetButtonsProps> = (props: TokenPresetButtonsProps) => {
  const [redoiToken, setRedoiToken] = useState<TokenMetadataItem | null>(null);
  // const [usdtToken, setUsdtToken] = useState<TokenMetadataItem | null>(null);

  const onTokenChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const element = evt.target;
    const {tokenName, tokenAddress, imgSrc}: {
      tokenName?: string,
      tokenAddress?: string,
      imgSrc?: string
    } = element.dataset;
    if (tokenName && tokenAddress && imgSrc) {
      props.onTokenAddressChange(tokenName, tokenAddress, imgSrc);
    }
  };

  useEffect(() => {
    if (props?.tokensMetadata?.length > 0) {
      const redoiTokenFounded: TokenMetadataItem | undefined = props.tokensMetadata.find((element: TokenMetadataItem) => element.symbol === REDOI_TOKEN)
      if (redoiTokenFounded) {
        setRedoiToken(redoiTokenFounded);
      }
    }
  }, [props.tokensMetadata]);

  return (
    <ButtonLabelsContainer>
      <input name="token-preset" id="TON_token" type="radio" value="TON" onChange={onTokenChange}
             checked={props.activeToken === 'TON'} data-token-name="TON" data-token-address="native"
             data-img-src="https://asset.ston.fi/img/EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c/ee9fb21d17bc8d75c2a5f7b5f5f62d2bacec6b128f58b63cb841e98f7b74c4fc"/>
      <ButtonLabel sx={{fontSize: '18px'}} htmlFor="TON_token">TON</ButtonLabel>
      {/*{usdtToken && <><input name="token-preset" id="USDT_token" type="radio" value="USDT"*/}
      {/*                       onChange={onTokenChange}*/}
      {/*                       checked={activeToken === 'USDT'}/></>}*/}
      {/*<ButtonLabel sx={{fontSize: '18px'}} htmlFor="USDT_token">USDT</ButtonLabel>*/}
      {redoiToken && <><input name="token-preset" id="REDOI_token" type="radio" value={REDOI_TOKEN}
                              onChange={onTokenChange} checked={props.activeToken === REDOI_TOKEN}
                              data-token-name={redoiToken.symbol} data-token-address={redoiToken.address}
                              data-img-src={redoiToken.image}/>
          <ButtonLabel sx={{fontSize: '18px'}} htmlFor="REDOI_token">{REDOI_TOKEN}</ButtonLabel></>}
    </ButtonLabelsContainer>
  );
}

export default TokenPresetButtons;